<template>
  <v-snackbar
    :timeout="timeOut"
    top
    v-model="snack"
    :color="color"
  >{{ message }}

    <v-btn
      v-if="isUpdate"
      dark
      text
      @click="aggiorna()"
    >
      Aggiorna
      <v-icon>refresh</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
import { EventBus } from "./toastEventBus";

export default {
  data: () => ({
    snack: false,
    message: "",
    timeOut: 4000,
    color: "",
    isUpdate: false,
  }),

  methods: {
    info(messaggio) {
      this.message = messaggio;
      this.color = "blue accent-3";
      this.timeOut = 4000;
    },
    warning(messaggio) {
      this.message = messaggio;
      this.color = "amber darken-2";
      this.timeOut = 4000;
    },
    success(messaggio) {
      this.message = messaggio;
      this.color = "green darken-1";
      this.timeOut = 4000;
    },
    error(messaggio) {
      this.message = messaggio;
      this.color = "deep-orange darken-3";
      this.timeOut = 4000;
    },
    update(messaggio) {
      this.message = messaggio;
      this.color = "blue accent-3";
      this.timeOut = 0;
      this.isUpdate = true;
    },
    handleToast(tipo, msg) {
      this.snack = !!msg;

      if (!this.snack) return;

      if (tipo == "info") this.info(msg);
      else if (tipo == "warning") this.warning(msg);
      else if (tipo == "success") this.success(msg);
      else if (tipo == "error") this.error(msg);
      else if (tipo == "update") this.update(msg);
    },

    aggiorna() {
      localStorage.removeItem("version");
      window.location.reload();
    },
  },

  beforeMount() {
    EventBus.$on("ToastMessage", this.handleToast);
  },

  beforeDestroy() {
    EventBus.$off("ToastMessage", this.handleToast);
  },
};
</script>
